<template>
	<div>
		<h1>LOGIN</h1>
		<div class="row">
			<div class="col-md-6 offset-md-3">
				<div class="panel panel-login">
					<div class="panel-body">
						<div class="row">
							<div class="col-lg-12">
								<div v-show="wrongCredentials" class="alert alert-danger">
									Wrong user name or password
								</div>
								<ValidationObserver ref="form">
									<form id="login-form" role="form" name="loginForm" method="post" v-on:submit.prevent>
										<validation-provider rules="email|required" v-slot="{errors,classes }">
											<div class="form-group">
												<input type="email" name="user_email" id="user_email" tabindex="1" class="form-control"
												       placeholder="Email" v-model="login.user_email"
												       :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<validation-provider rules="required" v-slot="{ errors,classes }">
											<div class="form-group">
												<input type="password" name="password" id="password" tabindex="2" class="form-control"
												       placeholder="Password" v-model="login.user_password" :class="classes">
												<div class="invalid-feedback">{{ errors[0] }}</div>
											</div>
										</validation-provider>
										<div class="form-group">
											<div class="row">
												<div class="col-sm-6 offset-md-3">
													<button type="submit" name="login-submit" id="login-submit" tabindex="4"
													        class="btn btn-primary" v-on:click="doLogin()">
														<i class="fas fa-sign-in-alt"></i> Log In
													</button>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-6 offset-md-3">
												<button type="button" class="btn btn-link" name="passReset-submit" tabindex="4"
												        href="javascript:void(0);" @click="showPassReset=true">Password reset
												</button>
											</div>
											<div v-if="showPassReset" class="col-12">
												<ValidationObserver ref="form">
													<form id="pass-reset-form" role="form" name="passresetForm" method="post" v-on:submit.prevent>
														<validation-provider rules="email|required" v-slot="{errors,classes }">
															<div class="form-group">
																<input type="email" name="pass_email" id="pass_email" tabindex="1" class="form-control"
																       placeholder="Email for password recovery" v-model="login.user_email"
																       :class="classes">
																<div class="invalid-feedback">{{ errors[0] }}</div>
															</div>
														</validation-provider>
														<div class="col-sm-6 offset-md-3">
															<button type="button" class="btn btn-secondary" name="passReset-submit" tabindex="4"
															        href="javascript:void(0);" @click="passReset()">Password reset
															</button>
														</div>
													</form>
												</ValidationObserver>
											</div>
										</div>
									</form>
								</ValidationObserver>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ApiService from "../../libs/ApiService";

	export default {
		name: "Login",
		data() {
			return {
				wrongCredentials: false,
				showPassReset: false,
				login: {
					user_email: '',
					user_password: ''
				}
			}
		},
		mounted() {
			ApiService.post('/auth/logout');
		},
		methods: {
			async doLogin() {
				//trigger validation
				if (!await this.$refs.form.validate()) {
					return;
				}
				let res = await ApiService.post('/auth/login', this.login);
				if (res.data) {
					await this.$store.dispatch('me/loadFromServer');
					if (this.$store.getters['me/isLoggedIn']) {
						//actual redirect
						this.$router.push('/backoffice/dashboard')
					} else {
						alert("General error #23");
					}

				} else {
					this.wrongCredentials = true;
				}

			},

			async passReset() {
				if (!await this.$refs.form.validate()) {
					return;
				}
				ApiService.post('/auth/passResetRequest', this.login).then(function (res) {
					alert("Please check your inbox");
				})
			}
		},

	}
</script>

<style scoped>

</style>